import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("be_cart") || "[]"); } catch { return []; }
  });
  useEffect(() => localStorage.setItem("be_cart", JSON.stringify(items)), [items]);

  const add = (item) => setItems((prev) => {
    const ex = prev.find((i) => i.slug === item.slug);
    if (ex) return prev.map((i) => (i.slug === item.slug ? { ...i, qty: i.qty + 1 } : i));
    return [...prev, { ...item, qty: 1 }];
  });
  const setQty = (slug, qty) => setItems((prev) => (qty <= 0 ? prev.filter((i) => i.slug !== slug) : prev.map((i) => (i.slug === slug ? { ...i, qty } : i))));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.qty * i.price, 0);

  return <CartCtx.Provider value={{ items, add, setQty, clear, count, subtotal }}>{children}</CartCtx.Provider>;
};

export const useCart = () => useContext(CartCtx);
